import { head } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import {
  DatavizHorizontalBarChart,
  updateDatavizOptions,
} from "@radarly/models/dataviz";

function getNullValuesOptions(locale: Locale) {
  return [
    {
      value: "false",
      label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::YES"),
    },
    {
      value: "true",
      label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::NO"),
    },
  ];
}

function getNullValuesOption(
  dataviz: DatavizHorizontalBarChart,
  locale: Locale
) {
  const options = getNullValuesOptions(locale);
  return typeof dataviz.displayNullValues === "boolean"
    ? String(dataviz.displayNullValues)
    : head(options)?.value;
}

export function useNullValues(
  dataviz: DatavizHorizontalBarChart,
  setDataviz: (dataviz: DatavizHorizontalBarChart) => void
) {
  const locale = useCurrentUserLocale();
  const options = getNullValuesOptions(locale);
  const option = getNullValuesOption(dataviz, locale);
  const onChange = (id: "true" | "false") => {
    setDataviz(
      updateDatavizOptions(dataviz, "displayNullValues", id === "true")
    );
  };
  return {
    label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::DISPLAY_NULL_VALUES"),
    options,
    option,
    onChange,
  };
}
